import { yupResolver } from "@hookform/resolvers/yup";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button, Input } from "ui";

import { SocialsData } from "../../../content.types";
import { socialsSchema } from "../../../helpers";
import { SocialsFormProps } from "./SocialsForm.types";

import styles from "./Socials.module.scss";

const SocialsForm = ({
  formId,
  defaultValues,
  onSubmit,
  isLoadingUpdate
}: SocialsFormProps) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<SocialsData>({
    defaultValues,
    resolver: yupResolver(socialsSchema)
  });

  return (
    <form id={formId} className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.form_inputs}>
        <Input
          label="Facebook"
          {...register("facebook")}
          errorMessage={errors.facebook?.message}
        />
        <Input
          label="Instagram"
          {...register("instagram")}
          errorMessage={errors.instagram?.message}
        />
        <Input
          label="WhatsApp"
          {...register("whatsApp")}
          errorMessage={errors.whatsApp?.message}
        />
      </div>
      <div className={styles.form_divider} />
      <Button
        type="submit"
        form={formId}
        variant={"primary"}
        className={styles.form_button}
        loading={isLoadingUpdate}
      >
        {t("Save")}
      </Button>
    </form>
  );
};

export default SocialsForm;
